/**
 * Infinite Scroll for Velora.ma - Shopify Collection Pages
 * =========================================================
 * 
 * INSTALLATION:
 * 1. Dkhol l Shopify Admin > Online Store > Themes
 * 2. Click "Edit Code" (Customize > "..." > Edit Code)
 * 3. Lqa file: layout/theme.liquid
 * 4. 9bal </body> tag, zid had l-code kamlo bin <script> tags
 * 
 * Ola:
 * 1. Dir fichier jdid f "Assets" folder, smiih "infinite-scroll.js"
 * 2. Copier had l-code fih
 * 3. F layout/theme.liquid, zid 9bal </body>:
 *    <script src="{{ 'infinite-scroll.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // Only run on collection pages
  if (!window.location.pathname.includes('/collections/')) return;

  // ─── Configuration ───
  const CONFIG = {
    // Selector for the product grid container
    productGridSelector: '#product-grid',
    // Selector for individual product items
    productItemSelector: '.grid__item',
    // Selector for the pagination nav to hide
    paginationSelector: 'nav.pagination',
    // How far from bottom (in px) to trigger next load
    triggerOffset: 800,
    // Fade-in animation duration (ms)
    animationDuration: 400,
  };

  // ─── State ───
  let currentPage = getCurrentPage();
  let totalPages = getTotalPages();
  let isLoading = false;
  let allLoaded = currentPage >= totalPages;

  function getCurrentPage() {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page')) || 1;
  }

  function getTotalPages() {
    // Try to find the last page number from pagination links
    const paginationLinks = document.querySelectorAll('nav.pagination a, .pagination a');
    let maxPage = 1;
    paginationLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href) {
        const match = href.match(/page=(\d+)/);
        if (match) {
          const pageNum = parseInt(match[1]);
          if (pageNum > maxPage) maxPage = pageNum;
        }
      }
    });
    // Also check current page text elements
    const pageNumbers = document.querySelectorAll('nav.pagination li, .pagination__item, .pagination span');
    pageNumbers.forEach((el) => {
      const num = parseInt(el.textContent.trim());
      if (!isNaN(num) && num > maxPage) maxPage = num;
    });
    return maxPage || 2; // Default to 2 if can't detect
  }

  // ─── Create Loading Spinner ───
  function createLoader() {
    const loader = document.createElement('div');
    loader.id = 'infinite-scroll-loader';
    loader.innerHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        gap: 8px;
      ">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             style="animation: infiniteScrollSpin 0.8s linear infinite;">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2.5"
                  fill="none" stroke-dasharray="50 20" stroke-linecap="round" />
        </svg>
        <span style="font-size: 14px; color: #666; font-family: inherit;">
          Chargement des produits...
        </span>
      </div>
    `;
    return loader;
  }

  // ─── Create "All Loaded" Message ───
  function createEndMessage() {
    const msg = document.createElement('div');
    msg.id = 'infinite-scroll-end';
    msg.innerHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px 20px;
        color: #999;
        font-size: 14px;
        font-family: inherit;
      ">
        ✓ Tous les produits ont été chargés
      </div>
    `;
    return msg;
  }

  // ─── Add CSS Animation ───
  function injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes infiniteScrollSpin {
        to { transform: rotate(360deg); }
      }
      @keyframes infiniteScrollFadeIn {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .infinite-scroll-new-item {
        animation: infiniteScrollFadeIn ${CONFIG.animationDuration}ms ease forwards;
      }
    `;
    document.head.appendChild(style);
  }

  // ─── Fetch Next Page ───
  async function loadNextPage() {
    if (isLoading || allLoaded) return;

    isLoading = true;
    const nextPage = currentPage + 1;
    const loader = document.getElementById('infinite-scroll-loader');
    if (loader) loader.style.display = 'flex';

    try {
      // Build URL for next page, keeping existing params (filters, sort, etc.)
      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find new products
      const newGrid = doc.querySelector(CONFIG.productGridSelector);
      if (!newGrid) {
        allLoaded = true;
        showEndMessage();
        return;
      }

      const newItems = newGrid.querySelectorAll(CONFIG.productItemSelector);
      if (newItems.length === 0) {
        allLoaded = true;
        showEndMessage();
        return;
      }

      // Append new products with staggered animation
      const grid = document.querySelector(CONFIG.productGridSelector);
      newItems.forEach((item, index) => {
        item.classList.add('infinite-scroll-new-item');
        item.style.animationDelay = `${index * 60}ms`;
        item.style.opacity = '0';
        grid.appendChild(item);
      });

      currentPage = nextPage;

      // Update URL without reload (for sharing / back button)
      // We set page=1 so the URL stays clean (all products are visible)
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('page');
      history.replaceState(null, '', cleanUrl.toString());

      // Check if we've loaded all pages
      if (nextPage >= totalPages) {
        allLoaded = true;
        showEndMessage();
      }
    } catch (err) {
      console.error('[Infinite Scroll] Error loading page:', err);
    } finally {
      isLoading = false;
      const loaderEl = document.getElementById('infinite-scroll-loader');
      if (loaderEl) loaderEl.style.display = 'none';
    }
  }

  function showEndMessage() {
    const loader = document.getElementById('infinite-scroll-loader');
    if (loader) loader.remove();
    const grid = document.querySelector(CONFIG.productGridSelector);
    if (grid && !document.getElementById('infinite-scroll-end')) {
      grid.parentNode.insertBefore(createEndMessage(), grid.nextSibling);
    }
  }

  // ─── Scroll Handler with IntersectionObserver ───
  function setupScrollObserver() {
    const grid = document.querySelector(CONFIG.productGridSelector);
    if (!grid) return;

    // Insert loader after grid
    const loader = createLoader();
    loader.style.display = 'none';
    grid.parentNode.insertBefore(loader, grid.nextSibling);

    // Use IntersectionObserver for better performance
    const sentinel = document.createElement('div');
    sentinel.id = 'infinite-scroll-sentinel';
    sentinel.style.height = '1px';
    loader.parentNode.insertBefore(sentinel, loader);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoading && !allLoaded) {
            loadNextPage();
          }
        });
      },
      {
        rootMargin: `${CONFIG.triggerOffset}px`,
      }
    );

    observer.observe(sentinel);
  }

  // ─── Hide Pagination ───
  function hidePagination() {
    const paginationElements = document.querySelectorAll(
      'nav.pagination, .pagination, .pagination-wrapper'
    );
    paginationElements.forEach((el) => {
      el.style.display = 'none';
    });
  }

  // ─── Auto-load if we start on page > 1 ───
  async function loadPreviousPages() {
    if (currentPage <= 1) return;

    const grid = document.querySelector(CONFIG.productGridSelector);
    if (!grid) return;

    // Store current items
    const currentItems = Array.from(grid.querySelectorAll(CONFIG.productItemSelector));

    // Load pages 1 to currentPage-1
    const allPreviousItems = [];

    for (let page = 1; page < currentPage; page++) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        const response = await fetch(url.toString());
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const pageGrid = doc.querySelector(CONFIG.productGridSelector);
        if (pageGrid) {
          const items = pageGrid.querySelectorAll(CONFIG.productItemSelector);
          items.forEach((item) => allPreviousItems.push(item));
        }
      } catch (e) {
        console.error(`[Infinite Scroll] Error loading page ${page}:`, e);
      }
    }

    // Prepend previous items before current ones
    if (allPreviousItems.length > 0) {
      const firstChild = grid.firstChild;
      allPreviousItems.forEach((item) => {
        grid.insertBefore(item, firstChild);
      });
    }
  }

  // ─── Init ───
  function init() {
    const grid = document.querySelector(CONFIG.productGridSelector);
    if (!grid) {
      // Fallback: try common Shopify grid selectors
      const fallbackSelectors = [
        '.collection-product-list',
        '.product-grid-container',
        '[data-collection-products]',
        '.grid.grid--2-col-tablet',
      ];
      for (const sel of fallbackSelectors) {
        if (document.querySelector(sel)) {
          CONFIG.productGridSelector = sel;
          break;
        }
      }
    }

    injectStyles();
    hidePagination();

    // If user landed on page 2+, load previous pages first
    if (currentPage > 1) {
      loadPreviousPages().then(() => {
        setupScrollObserver();
      });
    } else {
      setupScrollObserver();
    }

    // If already all loaded (single page), show end message
    if (allLoaded) {
      showEndMessage();
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();